/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pronunciation_Report_Word_RequiredInputs */

const en_pronunciation_report_word_required = /** @type {(inputs: Pronunciation_Report_Word_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a word or phrase.`)
};

const es_pronunciation_report_word_required = /** @type {(inputs: Pronunciation_Report_Word_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribe una palabra o frase.`)
};

/**
* | output |
* | --- |
* | "Enter a word or phrase." |
*
* @param {Pronunciation_Report_Word_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pronunciation_report_word_required = /** @type {((inputs?: Pronunciation_Report_Word_RequiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pronunciation_Report_Word_RequiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pronunciation_report_word_required(inputs)
	return en_pronunciation_report_word_required(inputs)
});